import request from './request';

export function getPlateRecognitionList(params) {
    return request('/vehicle-plate-recognition/list', {
        method: 'POST',
        params,
    });
}

export function getVehicleEntryList(params) {
    return request('/vehicle-entry/list', {
        method: 'POST',
        params,
    });
}

export function addVehicleIntoWhitelist(params) {
    return request('/vehicle-plate-recognition/whitelist', {
        method: 'POST',
        params,
    });
}

export function deleteVehicleFromWhitelist(plateNumber) {
    return request(`/vehicle-plate-recognition/whitelist?plateNumber=${plateNumber}`, {
        method: 'DELETE',
    });
}

export function getVehicleWhitelist(params) {
    return request('/vehicle-plate-recognition/whitelist', {
        method: 'GET',
        params,
    });
}
